class FixedDots extends HTMLElement {
  constructor() {
    super();
    this.observer = null;
    this.visibleHideSects = [];
  }

  handleLoad() {
    const ctx = this;
    const hideSections = document.querySelectorAll(".hide-fixed-dots-section");
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            ctx.visibleHideSects.push(entry.target);
          } else {
            ctx.visibleHideSects = ctx.visibleHideSects.filter(
              (sect) => sect !== entry.target
            );
          }
          document.body.classList.toggle(
            "hide-fixed-dots",
            ctx.visibleHideSects.length > 0
          );
        });
      },
      { threshold: 0.5 }
    );
    if (hideSections.length > 0) {
      hideSections.forEach((sect) => {
        ctx.observer.observe(sect);
      });
    } else {
      document.body.classList.remove("hide-fixed-dots");
    }
  }

  connectedCallback() {
    if (
      document.readyState === "complete" ||
      document.readyState === "loaded"
    ) {
      this.handleLoad().bind(this);
    } else {
      document.addEventListener("DOMContentLoaded", this.handleLoad.bind(this));
    }
  }

  disconnectedCallback() {
    document.removeEventListener(
      "DOMContentLoaded",
      this.handleLoad.bind(this)
    );
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }
}

customElements.define("fixed-dots", FixedDots);
